import dayjs, { Dayjs } from 'dayjs'

export const disableFutureDates = (current: Dayjs) => {
  return current && current > dayjs().endOf('day')
}
